"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadSelfServiceToken = loadSelfServiceToken;
exports.replaceIndividualPlaceholders = replaceIndividualPlaceholders;
exports.hideModuleContentAndShowError = hideModuleContentAndShowError;
exports.getRelevantContract = getRelevantContract;
/* eslint-disable @typescript-eslint/no-explicit-any */
var referral_game_api_1 = require("@src/api/referral-game-api");
var generator_const_1 = require("@src/const/dom-crud/generator.const");
var time_mapping_const_1 = require("@src/modules/shared/validation/time-mapping.const");
var object_service_1 = require("@src/services/object-service");
var settings_service_1 = require("@src/services/settings.service");
var translation_1 = __importDefault(require("@src/services/translation"));
var cash_dom_1 = __importDefault(require("cash-dom"));
var SELFSERVICETOKENKEY = 'ssid';
function loadSelfServiceToken() {
    var params = new URLSearchParams(window.location.search);
    var queryParams = Object.fromEntries(params.entries());
    var ssid = queryParams.ssid;
    if (!(ssid === null || ssid === void 0 ? void 0 : ssid.length)) {
        ssid = localStorage.getItem(SELFSERVICETOKENKEY);
    }
    if (!(ssid === null || ssid === void 0 ? void 0 : ssid.length)) {
        (0, generator_const_1._ShowErrorMessage)('Ungültiger Link');
        console.error('Missing params in URL:', queryParams, window.location.search);
        return;
    }
    localStorage.setItem(SELFSERVICETOKENKEY, ssid);
    return { ssid: ssid };
}
function replaceIndividualPlaceholders($container, individualWithOptions) {
    return __awaiter(this, void 0, void 0, function () {
        var baseContractId, baseContract, lastContract, selectedContract, individiualGetters, config, gameAPI, multiplier;
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return __generator(this, function (_l) {
            baseContractId = (_c = (_b = (_a = individualWithOptions.contractSwitchOptions[0]) === null || _a === void 0 ? void 0 : _a.sourceContracts) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.id;
            baseContract = (_d = individualWithOptions.contracts) === null || _d === void 0 ? void 0 : _d.find(function (c) { return c.id === baseContractId; });
            lastContract = (_e = individualWithOptions.contracts) === null || _e === void 0 ? void 0 : _e[((_g = (_f = individualWithOptions.contracts) === null || _f === void 0 ? void 0 : _f.length) !== null && _g !== void 0 ? _g : 0) - 1];
            selectedContract = baseContract !== null && baseContract !== void 0 ? baseContract : lastContract;
            individiualGetters = $container[0].querySelectorAll('[data-get]');
            config = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
            gameAPI = object_service_1.ObjectService.getInstance(referral_game_api_1.ReferralGameAPI);
            multiplier = (_k = (_j = (_h = config.get) === null || _h === void 0 ? void 0 : _h.pricePreview) === null || _j === void 0 ? void 0 : _j.globalPaymentFrequencyMultiplier) !== null && _k !== void 0 ? _k : 1;
            if (individiualGetters === null || individiualGetters === void 0 ? void 0 : individiualGetters.length) {
                individiualGetters.forEach(function (a) { return __awaiter(_this, void 0, void 0, function () {
                    var attr, scoreBoard, ownEntry, valKey, paymentDetails;
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                    return __generator(this, function (_k) {
                        switch (_k.label) {
                            case 0:
                                attr = a.getAttribute('data-get');
                                if (!(attr === 'customer.firstname')) return [3 /*break*/, 1];
                                a.innerHTML = (_b = (_a = individualWithOptions.individual) === null || _a === void 0 ? void 0 : _a.givenName) !== null && _b !== void 0 ? _b : '';
                                return [3 /*break*/, 4];
                            case 1:
                                if (!(attr === 'customer.lastname')) return [3 /*break*/, 2];
                                a.innerHTML = (_d = (_c = individualWithOptions.individual) === null || _c === void 0 ? void 0 : _c.familyName) !== null && _d !== void 0 ? _d : '';
                                return [3 /*break*/, 4];
                            case 2:
                                if (!(attr === 'gameScore')) return [3 /*break*/, 4];
                                return [4 /*yield*/, gameAPI.getHighscoresForGame((_f = (_e = config.get.referralGame) === null || _e === void 0 ? void 0 : _e.gameId) !== null && _f !== void 0 ? _f : '-')];
                            case 3:
                                scoreBoard = _k.sent();
                                ownEntry = scoreBoard.highscoreList.find(function (e) { var _a; return e.magiclineId === ((_a = individualWithOptions.individual.member) === null || _a === void 0 ? void 0 : _a.id); });
                                a.innerHTML = ownEntry ? (_g = ownEntry.totalScore) === null || _g === void 0 ? void 0 : _g.toString() : translation_1.default.t('Not in leaderboard');
                                _k.label = 4;
                            case 4:
                                if (attr.startsWith('contract.') && selectedContract) {
                                    valKey = attr.replace('contract.', '');
                                    if (valKey === 'paymentFrequency') {
                                        paymentDetails = (_j = (_h = selectedContract === null || selectedContract === void 0 ? void 0 : selectedContract.priceDetails) === null || _h === void 0 ? void 0 : _h.paymentFrequency) === null || _j === void 0 ? void 0 : _j.term;
                                        if ((paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.value) && (paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.unit)) {
                                            a.innerHTML = (0, time_mapping_const_1.formatValueWithUnit)(paymentDetails.value * multiplier, paymentDetails === null || paymentDetails === void 0 ? void 0 : paymentDetails.unit, true);
                                        }
                                    }
                                    else if (valKey === 'price') {
                                        a.innerHTML = (selectedContract.price * multiplier).toString();
                                    }
                                    else if (valKey === 'term') {
                                        a.innerHTML = (0, time_mapping_const_1.formatValueWithUnit)(selectedContract.term.periodValue, selectedContract.term.periodUnit, false);
                                    }
                                    else if (valKey === 'name') {
                                        a.innerHTML = selectedContract.rateName;
                                    }
                                    else if (selectedContract[valKey]) {
                                        a.innerHTML = selectedContract[valKey];
                                    }
                                }
                                return [2 /*return*/];
                        }
                    });
                }); });
            }
            return [2 /*return*/];
        });
    });
}
function hideModuleContentAndShowError($container, errorMessage) {
    var $errorField = (0, cash_dom_1.default)('#' + 'error_msg').clone();
    $container.empty();
    // If no template exists, create a minimal one
    if (!($errorField === null || $errorField === void 0 ? void 0 : $errorField.length)) {
        $errorField = (0, cash_dom_1.default)("<div id=\"error_msg\" class=\"error-msg\" style=\"padding:12px;border:1px solid #f5c2c7;background:#f8d7da;border-radius:8px;\"></div>");
    }
    $container.append($errorField);
    (0, generator_const_1._ShowErrorMessage)(errorMessage);
}
function getRelevantContract(contracts) {
    var _a;
    var validContracts = (_a = contracts === null || contracts === void 0 ? void 0 : contracts.filter(function (contract) { return contract.reversed !== true && contract.revoked !== true && contract.cancelled !== true; })) !== null && _a !== void 0 ? _a : [];
    var getContractDate = function (contract) { var _a, _b; return (_b = (_a = contract.startDate) !== null && _a !== void 0 ? _a : contract.createdDate) !== null && _b !== void 0 ? _b : 0; };
    var sortByLatestDate = function (a, b) {
        return getContractDate(b) - getContractDate(a);
    };
    var activeContract = validContracts.filter(function (contract) { return contract.contractStatus === 'ACTIVE'; }).sort(sortByLatestDate)[0];
    return activeContract !== null && activeContract !== void 0 ? activeContract : validContracts.sort(sortByLatestDate)[0];
}
